import { ImagePrimitive, ResponsiveContainer, styled } from '@arpeggi/ui'
import { FC } from 'react'

const Root = styled('div', {
  overflow: 'hidden',
  position: 'relative',
  minHeight: '100vh'
})

const Flare: FC<{ type: 'one' | 'two' }> = ({ type }) => {
  const src = type === 'one' ? '/static/images/flare1.png' : '/static/images/flare2.png'
  const css = type === 'one' ? { top: '-100px', left: '-300px' } : { top: '350px', right: '-300px' }
  return (
    <ImagePrimitive.Root css={{ position: 'absolute', width: '700px', height: '700px', ...css }}>
      <ImagePrimitive.Image src={src} />
    </ImagePrimitive.Root>
  )
}

const Content = styled(ResponsiveContainer, {
  paddingTop: '40px',
  position: 'relative'
})

const Title = styled('div', {
  color: '$black',
  text: '36',
  fontWeight: 700,
  marginBottom: '8px',
  variants: {
    small: {
      true: {
        text: '24'
      }
    }
  }
})

const Subtitle = styled('div', {
  color: '$blackA400',
  text: '16',
  marginBottom: '36px'
})

export const Page = { Root, Content, Title, Subtitle, Flare }
